import { useSelector } from "react-redux";

export function useAdvisors() {
  return useSelector((state) => state.advisors);
}
